const stop = () => {
  const body = document.body;
  const html = document.documentElement;
  body.style.overflow = "hidden";
  body.style.touchAction = "none";
  html.style.overflow = "hidden";
  html.style.touchAction = "none";
};
const move = () => {
  const body = document.body;
  const html = document.documentElement;
  body.style.overflow = "";
  body.style.touchAction = "";
  html.style.overflow = "";
  html.style.touchAction = "";
}; //出现滚动条

const popDiv = document.createElement("div");
popDiv.id = "pop";
document.body.appendChild(popDiv);

export default {
  clearPopFunc() {
    const pop = document.getElementById("pop");
    while (pop.firstChild) {
      pop.removeChild(pop.firstChild);
    }
    this.$nextTick(move);
  },
  popFunc(bool, that) {
    return Promise.resolve().then((_) => {
      setTimeout(() => {
        const pop = document.getElementById("pop");
        bool ? stop() : move();
        if (pop.append) {
          pop.append(that.$el);
        } else {
          pop.appendChild(that.$el);
        }
      }, 0);
    });
  },
};
